'use client';
import { ComponentProps } from 'react';
import { useGetPageUrl } from '@/schema/useGetPageUrl';
import { Link as NextLink } from '@/shared/i18n/navigation';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const LinkBox = ({ text: _, href, media, children, ...props }: Props) => {
    const getPageUrl = useGetPageUrl();
    const [prefix, ...parts] = href.split(':');
    const linkHref = prefix.startsWith('page') ? getPageUrl(parts.join('')) : href;
    return (
        <Layout
            element={NextLink}
            media={{ ...media, initial: { display: undefined, flexDirection: undefined, ...media?.initial } }}
            href={linkHref}
            {...props}
        >
            {children}
        </Layout>
    );
};
